<div id="kt_content" class="kt-content  kt-grid__item kt-grid__item--fluid">
    <div class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__body">
            <!-- Filter -->
            <div class="kt-form kt-form--label-right">
                <div class="row align-items-center">
                    <div class="col-xl-12 order-2 order-xl-1 pr-0">
                        <form class="row align-items-center" [formGroup]="form">
                            <div class="col-12 row pr-0">
                                <!-- Username -->
                                <div class="col-md-1 kt-form__label col-form-label">
                                    <label>Username:</label>
                                </div>
                                <div class="col-md-2 kt-form__control">
                                    <input type="text" formControlName="username" (input)="toLowerCaseInput('username', $event)" placeholder="Search" class="form-control">
                                </div>
                                <!-- Currency -->
                                <div class="col-md-1 kt-form__label col-form-label">
                                    <label>Currency:</label>
                                </div>
                                <div class="col-md-2 kt-form__control">
                                    <select formControlName="currency_id" class="form-control">
                                        <option value="all"> All </option>
                                        <option [value]="value.id" *ngFor="let value of dropdown.currencies">
                                            {{ value.name }}
                                        </option>
                                    </select>
                                </div>
                                <!-- Platform -->
                                <div class="col-md-1 kt-form__label col-form-label">
                                    <label>Platform:</label>
                                </div>
                                <div class="col-md-2 kt-form__control">
                                    <select formControlName="platform" class="form-control">
                                        <option value="all"> All </option>
                                        <option [value]="value.id" *ngFor="let value of dropdown.platforms">
                                            {{ value.name }}
                                        </option>
                                    </select>
                                    <!-- One row per member only. With Include ticked each row is one device, and the
                                         filter matches that device's own platform. -->
                                    <small class="form-text text-muted" *ngIf="!form.value.show_anonymous">Matches members who used this platform on any device.</small>
                                </div>
                            </div>
                            <div class="col-12 row pr-0 mt-2">
                                <!-- Created Date -->
                                <div class="col-md-1 kt-form__label col-form-label">
                                    <label>Created Date:</label>
                                </div>
                                <div class="col-md-5 kt-form__control">
                                    <div class="input-group date">
                                        <input type="hidden" formControlName="start_datetime">
                                        <input type="hidden" formControlName="end_datetime">

                                        <!-- No [opens]: with 'right' the library sets left = offsetLeft with no
                                             off-screen guard, so the panel can land outside the viewport. The
                                             default 'auto' clamps a negative position. -->
                                        <!-- The format onTypedDateRange() accepts, so an operator whose typed range
                                             was cleared can see what to type. -->
                                        <input type="text" class="form-control" #dateRangeInput
                                            [placeholder]="dateTimePickerLocale.format + ' - ' + dateTimePickerLocale.format"
                                            (change)="onDateRange($event)" formControlName="defaultDate"
                                            [timePicker]="true" [timePickerSeconds]="true"
                                            [alwaysShowCalendars]="true" [ranges]="ranges"
                                            [showCustomRangeLabel]="true" [locale]="dateTimePickerLocale"
                                            [timePicker24Hour]="true" [showDropdowns]="true"
                                            (click)="updateDateRange()" ngxDaterangepickerMd />
                                        <span class="input-group-append">
                                            <span class="input-group-text pointer-calendar" (click)="onClearDate()">X</span>
                                        </span>
                                    </div>
                                </div>
                                <!-- Include anonymous -->
                                <div class="col-md-1 kt-form__label col-form-label">
                                    <label>Anonymous:<i class="fa fa-info-circle ml-1" placement="bottom" container="body" [ngbTooltip]="anonymousToolTip" tooltipClass="pwa-tooltip"></i></label>
                                </div>
                                <div class="col-md-2 kt-form__control d-flex align-items-center">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" id="show_anonymous" formControlName="show_anonymous">
                                        <label class="custom-control-label text-nowrap" for="show_anonymous">Include</label>
                                    </div>
                                </div>

                                <!-- Follows the table on screen, as the Device Count header does: with
                                     Include ticked each row is one device and shows its own platform. -->
                                <ng-template #platformToolTip>
                                    <div class="text-left" *ngIf="isMemberGrain">
                                        The device this member used most recently.<br>
                                        The Platform filter lists members who used that platform on any device, so a
                                        member with an Android phone and a newer iPhone shows ios under Android.<br>
                                        Open Actions to see every device.
                                    </div>
                                    <div class="text-left" *ngIf="!isMemberGrain">This device's platform.</div>
                                </ng-template>

                                <ng-template #devicesToolTip>
                                    <div class="text-left">
                                        How many separate installs this member has, not the device type.<br>
                                        Each install is counted by the app's own storage, so a reinstall, a move
                                        to a new domain, or clearing site data adds one.<br>
                                        Open Actions to see them listed.
                                    </div>
                                </ng-template>

                                <!-- Last Active Date and Last Login Date are two columns from two fields,
                                     as in the details dialog. The list once had one column headed "Last
                                     Login Date" that sorted and showed last_active_at, so a player who only
                                     ever resumes the app read as having "logged in" today here and three
                                     weeks ago in the dialog. The AC asks to show and sort by the last login,
                                     so last_login_at now has a column of its own. -->
                                <ng-template #lastActiveToolTip>
                                    <div class="text-left">
                                        The last time this member opened the installed app — a cold start or a
                                        return from the background.<br>
                                        Not the last time they signed in. The per-device dialog shows Last
                                        Login separately.
                                    </div>
                                </ng-template>

                                <ng-template #anonymousToolTip>
                                    <div class="text-left">
                                        Off: one row per member.<br>
                                        On: one row per device, including devices nobody has ever logged in on.<br>
                                        Username and Currency filters always exclude anonymous rows.
                                    </div>
                                </ng-template>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!-- Filter Action -->
            <div class="kt-section col-12 row mb-3 mt-3">
                <div class="dropdown dropdown-inline">
                    <kt-search-button [loading]="searchBtnLoading" [disabledButton]="loading" (search)="onSubmit()"></kt-search-button>
                    <kt-clear-button [loading]="clearBtnLoading" [disabledButton]="loading" (clear)="onClear()"></kt-clear-button>
                </div>
            </div>
            <!-- Total -->
            <div class="kt-section col-12 row mb-2">
                <span class="kt-font-bold">Total Member: {{ memberTotal | number : '1.0' }}</span>
            </div>
            <!-- Table -->
            <div class="kt-section">
                <div class="kt-section__content">
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover table-striped table-sortable">
                            <thead>
                                <tr>
                                    <th>Username</th>
                                    <th>Phone</th>
                                    <th>Name</th>
                                    <th class="text-center">Currency</th>
                                    <th class="text-center">Platform<i
                                            class="fa fa-info-circle ml-1" placement="bottom" container="body"
                                            [ngbTooltip]="platformToolTip" tooltipClass="pwa-tooltip"></i></th>
                                    <!-- Sortable only on the member grain. With Include ticked every row is one
                                         device and the column is a constant, so the sort is withheld rather than
                                         offered and ignored. -->
                                    <th class="text-center"
                                        [class.sort-enabled]="isMemberGrain"
                                        [ngClass]="isMemberGrain ? sortingConfig.device_count : ''"
                                        [class.sort-selected]="isMemberGrain && sortingSelection.sort_by === 'device_count'"
                                        (click)="onSortColumn('device_count')">Device Count<i
                                            class="fa fa-info-circle ml-1" placement="bottom" container="body"
                                            [ngbTooltip]="devicesToolTip" tooltipClass="pwa-tooltip"
                                            (click)="$event.stopPropagation()"></i></th>
                                    <th class="date-column sort-enabled" (click)="onSortColumn('first_launch_at')"
                                        [ngClass]="sortingConfig.first_launch_at"
                                        [class.sort-selected]="sortingSelection.sort_by === 'first_launch_at'">Created Date</th>
                                    <th class="date-column sort-enabled" (click)="onSortColumn('last_active_at')"
                                        [ngClass]="sortingConfig.last_active_at"
                                        [class.sort-selected]="sortingSelection.sort_by === 'last_active_at'">Last Active Date<i
                                            class="fa fa-info-circle ml-1" placement="bottom" container="body"
                                            [ngbTooltip]="lastActiveToolTip" tooltipClass="pwa-tooltip"
                                            (click)="$event.stopPropagation()"></i></th>
                                    <th class="date-column sort-enabled" (click)="onSortColumn('last_login_at')"
                                        [ngClass]="sortingConfig.last_login_at"
                                        [class.sort-selected]="sortingSelection.sort_by === 'last_login_at'">Last Login Date</th>
                                    <th class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody *ngIf="(pwaUsage$ | async) as rows">
                                <tr *ngFor="let row of rows">
                                    <!-- Text only, per the AC: no member dialog on the username. -->
                                    <td>{{ row.username ? row.username : 'Anonymous' }}</td>
                                    <td>{{ row.mobile ? row.mobile : '-' }}</td>
                                    <td>{{ row.name ? row.name : '-' }}</td>
                                    <td class="text-center">{{ row.currency ? row.currency : '-' }}</td>
                                    <td class="text-center">{{ row.platform ? row.platform : '-' }}</td>
                                    <td class="text-center">{{ row.device_count ? row.device_count : '-' }}</td>
                                    <td>{{ row.first_launch_at ? (row.first_launch_at | timezoneDate: 'YYYY-MM-DD HH:mm:ss') : '-' }}</td>
                                    <td>{{ row.last_active_at ? (row.last_active_at | timezoneDate: 'YYYY-MM-DD HH:mm:ss') : '-' }}</td>
                                    <td>{{ row.last_login_at ? (row.last_login_at | timezoneDate: 'YYYY-MM-DD HH:mm:ss') : '-' }}</td>
                                    <td class="text-center">
                                        <button matTooltip="View PWA Details"
                                            class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"
                                            (click)="onOpenDetails(row)" *ngIf="row.member_id">
                                            <i class="fas fa-mobile-alt"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody shared-table-handler [loading]="loading" [dataLength]="dataLength" class="text-gray-600 fw-bold"></tbody>
                        </table>
                    </div>
                    <div class="kt-pagination kt-pagination--brand mt-2" *ngIf="pagination !== undefined">
                        <ngb-pagination [pageSize]="pageSize" [(page)]="page" [maxSize]="maxSize"
                            [directionLinks]="true" [boundaryLinks]="true" [rotate]="true"
                            [collectionSize]="pagination.total" (pageChange)="onViewPageBy(page)">
                        </ngb-pagination>
                        <div class="kt-pagination__toolbar">
                            <select (change)="onPerPage($event)" [(ngModel)]="pageSize" [ngModelOptions]="{standalone: true}"
                                class="form-control kt-font-brand page-size">
                                <option [value]="item" *ngFor="let item of dropdown.perPage">{{ item }}</option>
                            </select>
                            <span class="pagination__desc">
                                Showing {{pagination.from}} to {{pagination.to}} of
                                {{ pagination.total | number : '1.0' }} records
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- A visitor id lives in one browser profile on one domain: a reinstall, a domain
                 change, or (on iOS) the gap between Safari and the installed app all produce a
                 new one. Device counts are therefore an upper bound. -->
            <div class="kt-section col-12 row mt-2">
                <small class="text-muted">
                    Note: this page only counts sessions launched from the installed app — ordinary browser
                    visits are never recorded. Installs cannot be counted directly either: iOS reports no
                    install event, and a device is identified only by the app's own storage, so a reinstall,
                    a move to a new domain, or clearing site data starts a new device row for the same
                    person. Device counts are an upper bound; member counts are exact. The Platform filter lists
                    members who used that platform on any device; the Platform column shows the device they used
                    most recently, so the two can differ for a member with more than one device.
                </small>
            </div>
        </div>
    </div>
</div>
